import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Siempre terminaba comprando perfiles por recomendación o intuición y después aparecían problemas: material de más, medidas mal calculadas o perfiles que no eran los adecuados. Con los manuales entendí qué elegir y por qué. En mi último trabajo ahorré tiempo y dejé de improvisar.',
  author: 'Carlos Méndez',
  role: 'Instalador independiente'
}, {
  quote: 'Llevo años trabajando, pero me di cuenta de que muchas veces hacía las cosas por costumbre y no por método. Lo que más me gustó fue que está explicado de manera práctica, sin vueltas. Los proyectos y ejemplos reales me ayudaron a ordenar mi forma de trabajar.',
  author: 'Fernando Ruiz',
  role: 'Constructor'
}, {
  quote: 'Quería aprender sobre perfiles de aluminio pero todo lo que encontraba estaba demasiado técnico o desordenado. Acá encontré algo paso a paso. Sentí que alguien me estaba guiando desde cero hasta proyectos más avanzados.',
  author: 'Martín Herrera',
  role: 'Emprendedor / Principiante'
}];
export function Testimonials() {
  return <section id="testimonios" className="py-24 relative" data-id="element-228">
      <div className="container mx-auto px-6" data-id="element-229">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-230">
          <h2 className="text-4xl md:text-5xl font-bold font-heading mb-6" data-id="element-231">
            Opiniones de alumnos
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-232">
          {testimonials.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} className="glass-panel rounded-2xl p-8 flex flex-col" data-id="element-233">
              <div className="flex gap-1 mb-6" data-id="element-234">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-500 text-amber-500" data-id="element-235" />)}
              </div>

              <blockquote className="text-lg text-gray-300 mb-8 flex-grow leading-relaxed" data-id="element-236">
                "{item.quote}"
              </blockquote>

              <div className="flex items-center gap-4" data-id="element-237">
                <div className="w-12 h-12 rounded-full bg-[#2F80ED]/20 flex items-center justify-center font-bold text-[#2F80ED]" data-id="element-238">
                  {item.author.charAt(0)}
                </div>
                <div data-id="element-239">
                  <div className="font-bold text-white" data-id="element-240">{item.author}</div>
                  <div className="text-sm text-gray-500" data-id="element-241">{item.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}